import React from "react";
import styled from 'styled-components'
import ProductContainer from 'Pages/PlayerDashboard/PostGame/Products/ProductContainer.js'
import mixpanel from "lib/mixpanel"


const Unlocked = (props) => {
	const imageUnlockedLogo = "https://s3.us-east-2.amazonaws.com/remoteadventures.theescapegame.com/themes/the-heist/post-game/unlocked-logo.png"
	const imageUnlocked = "https://s3.us-east-2.amazonaws.com/remoteadventures.theescapegame.com/themes/the-heist/post-game/unlocked-games.png"
	const link = "https://theescapegame.com/unlocked/"

	const clickEvent = (e) => {
		e.preventDefault()
		const mixpanelTracking = {
			...props.tracking,
			"advertisement_copy": e.currentTarget.parentNode.querySelector('.mixpanel-copy').innerText,
			"advertisement_cta_copy": e.currentTarget.innerText,
			"advertisement_cta_link": e.currentTarget.getAttribute('href'),
			"advertisement_image": e.currentTarget.parentNode.querySelector('.mixpanel-image').getAttribute('src'),
			"advertisement_product": "Unlocked"
		}
		mixpanel.track('Advertisement Click', mixpanelTracking)
		window.location.href = link
	}
	
	return (
		<ProductContainer>
			<ImageLogo src={imageUnlockedLogo} />
			<Image className="mixpanel-image" src={imageUnlocked} />
			<Text className="mixpanel-copy">Continue the adventure and capture curator-turned-thief, Vincent Hahn in our digital game series, UNLOCKED!</Text>
			<Button href={link} className="mixpanel-cta" onClick={clickEvent}>Learn more</Button>
		</ProductContainer>
	)
}

export default Unlocked


const ImageLogo = styled.img`
	margin-bottom: 30px;
	max-width: 175px;
	width: 100%;
`
const Image = styled.img`
	width: 100%;
`
const Text = styled.p`
	color: #000;
	font-size: 24px;
	line-height: 1;
	margin: 30px 0;
	width: 100%;
`
const Button = styled.a`
	background: linear-gradient(45deg, #f30222, #431650);
	border-radius: 9999px;
	display: block;
	color: #fff !important;
	cursor: pointer;
	font-size: 24px;
	padding: 8px 12px;
	transition: opacity .2s;
	&:hover {
		color: #fff;
		opacity: .75;
		text-decoration: none;
	}
`
